import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SidebarItem } from '../../model/sidebar-item';

@Component({
  selector: 'app-sidebar-item',
  templateUrl: './sidebar-item.component.html',
  styleUrls: ['./sidebar-item.component.scss']
})
export class SidebarItemComponent implements OnInit {
  @Input() item: SidebarItem;
  hasCustomIconFont: boolean;

  @Input() overrideClick: Function;

  constructor(private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    this.hasCustomIconFont = typeof this.item.icon !== 'string' && !!this.item.icon.font;
  }

  isSelected(path): boolean {
    return window.location.pathname === path;
  }

  handleClick(path): void {
    if (this.item.overrideClick) {
      return this.item.overrideClick();
    } else {
      // `router.url` inclui queryParams (ex.: `/reviews?preset=...`), o
      // `path` do item não. Compara só o pathname pra decidir se precisa
      // forçar re-init do componente — sem isso, clicar no botão da
      // sidebar quando queryParams estão presentes só limpa a URL e reusa
      // o componente (Angular NÃO recria em mesma rota), dando a impressão
      // de "primeiro clique não funciona".
      const currentPath = this.router.url.split('?')[0].split('#')[0];
      if (currentPath === path) {
        this.router.navigate(['/loading'], { skipLocationChange: true }).then(() => this.router.navigate([path]));
      }
    }
  }

  // Badge com `link` vira clicável. Sempre re-força o loading→destino pra
  // garantir que o ReviewsComponent re-inicialize e leia queryParams do
  // preset — se o usuário já estiver em /reviews, um routerLink puro
  // não dispararia recreate.
  handleBadgeClick(event: Event, badge: any): void {
    event.stopPropagation();
    event.preventDefault();
    if (!badge?.link) { return; }
    const dest = { path: badge.link, extras: { queryParams: badge.queryParams } };
    this.router.navigate(['/loading'], { skipLocationChange: true })
      .then(() => this.router.navigate([dest.path], dest.extras));
  }
}
